<template>
  <v-container fill-height fluid grid-list-xl>
   

    <v-layout wrap>
        <h4>Upload File Downloadable Video Url</h4>
       <v-flex md12>               
        <input ref="fileDownloadableUrl" type="file" @change="importExcel($event)" class="uploadDownloadableUrls" id="upload" /> 
      </v-flex>

      <v-flex xs12 md6>
        <material-card color="green" title="Add Chapter" text="Select course, subject and type chapter name and hit submit">
      <v-form
      ref="chapterFrom"
      v-model="valid"
      lazy-validation
      >
          <v-select
            :items="courseList"
            label="Select Course"
            item-text="name"
            item-value="id"
            v-model="chapter.course_id"
            class="mt-4"
            @change="onSelectCourse(chapter.course_id)"
            :rules="courseIDRules"
          ></v-select>
          <v-select
            :items="courseSubjectList"
            label="Select Subject"
            item-text="name"
            item-value="subject_id"
            v-model="chapter.subject_id"
            class="mt-4"
            :rules="subject_IDRules"
            @change="onSelectSubject(chapter.course_id, chapter.subject_id)"
          ></v-select>
          <v-text-field
            label="Chapter name"
            name="chapter_name"
            class="green-input"
            v-model="chapter.name"
            :rules="chapterNameRules"
            prepend-icon="text_fields"
          />
          
          <v-text-field
            label="Chapter name (Bangla)"
            name="chapter_name_bn"
            class="green-input"
            v-model="chapter.name_bn"
            :rules="chapterNameBnRules"
            prepend-icon="text_fields"
          />
          
              <v-text-field
                type="number"
                label="Price"
                class="green-input"
                v-model="chapter.price"
                prepend-icon="text_fields"
                :rules="priceRule"
              />
          <v-flex xs12 text-xs-right>
            <v-btn class="mx-0 font-weight-light" color="success" @click="onSubmitChapter">Submit</v-btn>
          </v-flex>
      </v-form>

        </material-card>
      </v-flex>
      <v-flex xs12 md6>
        <material-card
          color="green"
          title="Chapter List"
          text="All chapters"
        >
          <!-- {{ courseDetails.name }} -->
          <v-data-table :headers="headers" :items="chapterList">
            <!-- <template slot="headerCell" slot-scope="{ header }">
              <span class="subheading font-weight-light text--darken-3" v-text="header.text" />
            </template> -->
            <template slot="items" slot-scope="{ item }">
              <td><router-link  :to="'/chapter-details/'+item.course_id +'/'+item.subject_id +'/' +item.id">{{ item.name }}</router-link></td>
              <td><router-link  :to="'/chapter-details/'+item.course_id +'/'+item.subject_id +'/' +item.id">{{ item.name_bn }}</router-link></td>
              <td>
                
               <v-btn type="button" color="success" fab small dark round @click="editChapter(item)">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
              </td>
            </template>
          </v-data-table>
        </material-card>
        <v-dialog v-model="dialogChapter" width="1000" hegiht="auto">
          <template v-slot:activator="{ on }">
              
          </template>
          <v-card>
            <FormChapterEdit
              :Item="chapterItem"
              :Field="chapterInputFields"
              :Value="chapterObj"
              @emitted="updateChapterForm"
              @closed="closeModal"
              />

          </v-card>
        </v-dialog>
        <v-snackbar
          :color="color"
          :bottom="bottom"
          :top="top"
          :left="left"
          :right="right"
          v-model="snackbar"
          dark
        >
          <v-icon color="white" class="mr-3">mdi-bell-plus</v-icon>
          <div>{{ noticeMessage }}</div>
          <v-icon size="16" @click="snackbar = false">mdi-close-circle</v-icon>
        </v-snackbar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import xlsx from "xlsx";
import { mapGetters, mapActions, mapState } from "vuex";
import FormChapterEdit from '@/views/FormChapterEdit'
export default {
  components: {
    FormChapterEdit
  },
  metaInfo() {
    return {
      title: "Course Details | Admin"
    };
  },
  computed: {
    ...mapState("course_subjects", [
      "courseList",
      "courseSubjectList",
      "subjectListNotInCourse",
      "chapterList",
    ])
  },
  mounted() {
    this.getcourselist();
    this.getCourseSubjectList(this.$route.params.id);
    this.getCourseDetails(this.$route.params.id);
  },
  data() {
    return {
      excelUrls: [],
      dialogChapter: false,
      valid: true,
      color: null,
      chapter: {},
      colors: ["warning"],
      top: true,
      bottom: false,
      left: false,
      right: false,
      snackbar: false,
       chapterItem: {
        'title': 'Edit Chapter',
        'width': 'md6',
        'submitText' : 'Update'
      },
      chapterInputFields: [
        {
          label: 'Chapter Name',
          type: 'text',
          isEnable: true,
          name: 'name',
          formName: 'Chapter name',
          nameRules: [
            v => !!v || 'Chapter name is required',
            v => (v && v.length <= 190) || 'Chapter name must be less than 190 characters'
          ]
        },
        {
          label: 'Chapter Name Bangla',
          type: 'text',
          isEnable: true,
          name: 'name_bn',
          formName: 'Chapter name bangla',
          nameRules: [
            v => !!v || 'Chapter name Bangla is required',
            v => (v && v.length <= 190) || 'Chapter name Bangla must be less than 190 characters'
          ]
        },
        {
          label: 'Price',
          type: 'number',
          isEnable: true,
          name: 'price',
          formName: 'price',
          nameRules: [
            v => !!v || 'Price is required'
          ]
        }
      ],
      headers: [
        {
          sortable: true,
          text: "Chapter",
          value: "name"
        },
        {
          sortable: true,
          text: "Chapter (Bangla)",
          value: "name_bn"
        },
        {
          sortable: false,
          text: "Action",
          value: ""
        }
      ],
      dialog: false,
      noticeMessage: "",
      chapterObj: {},
      valueObj: {},
      chapterNameRules: [
        v => !!v || "Chapter Name is required"
      ],
      chapterNameBnRules: [
        v => !!v || "Chapter Name Bangla is required"
      ],
      subject_IDRules: [
        v => !!v || "Please select subject",
      ],
      courseIDRules :[
        v => !!v || "Please select subject",
      ],
      priceRule : [
         v => !!v || "Price is required",
      ]
    };
  },
  created() {},
  methods: {
    ...mapActions("course_subjects", [
      "fetchData",
      "CreateCourse",
      "getcourselist",
      "getCourseSubjectList",
      "getSubjectListNotInCourse",
      "addSubjectToCourse",
      "getCourseDetails",
      "getChapterNameListBySubjectId",
      "storeChapter",
      "updateChapter",
      "uploadDownloadUrls"
    ]),


    importExcel(e) {   

      const files = e.target.files;  
      
      if (!files.length) {
        return;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        return alert(
          "The upload format is incorrect. Please upload xls or xlsx format"
        );
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          const data = ev.target.result;
          const XLSX = xlsx;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // Generate JSON table content，wb.Sheets[Sheet名]    Get the data of the first sheet
        //  const excellist = []; // Clear received data
   
          this.excelUrls = [];
          // Edit data
          for (var i = 0; i < ws.length; i++) {  
            if(ws[i].id && ws[i].download_url)    {
              this.excelUrls.push({
                id:  Number(ws[i].id),   
                download_url: ws[i].download_url
              });
            }     
          
            //excelRecipientList
         //   excellist.push(ws[i]);
          }
         
          if(this.excelUrls.length > 0){
            this.uploadUrls();
          //  console.log(this.excelUrls);         
          }

         } catch (e) {
          return alert(e);
        }
      };
      fileReader.readAsBinaryString(files[0]);
      // var input = document.getElementById("upload");
      // input.value = "";
    },
    async uploadUrls() {

      let urls = [];
      let response;

      urls = this.excelUrls


      if (urls.length > 0) {      
       response = await this.uploadDownloadUrls({items: urls});
      }
 
      let loader = this.$loading.show({
              color: "green",
              canCancel: true,
              onCancel: this.onCancel,
              loader: 'dots',
              isFullPage: true
            });

      if (response.status === "Ok") {
        this.color = "success";
        this.subject_id = null;
        this.noticeMessage = "Success! " + response.messages +" Updated:" + response.updated +". NotFound:"+response.not_found;
        this.snack("top");    
        loader.hide()   
        this.excelUrls = [];   
        var input = document.getElementsByClassName("uploadDownloadableUrls");
        input.value = null;         
        this.$refs.fileDownloadableUrl.value=null;
      } else {
          this.color = "warning";
          this.noticeMessage = "Warning! " + response.messages;
          this.snack("top");
          loader.hide()
      }
    },
    onSelectCourse(course_id) {
      this.chapter.subject_id = null;
      this.$refs.chapterFrom.resetValidation()
      this.getCourseSubjectList(course_id);
    },
    onSelectSubject(course_id, subject_id) {
    let obj = {
      courseId : course_id,
      subjectId : subject_id
    }
      this.getChapterNameListBySubjectId(obj);
    },
    onSubmitChapter() {
      if (this.$refs.chapterFrom.validate()) {
      this.storeChapter(this.chapter).then(response => {
        if (response.status == "OK") {
          let obj = {
            courseId : this.chapter.course_id,
            subjectId : this.chapter.subject_id
          }
          this.chapter.name = null
          this.chapter.name_bn = null
          this.$refs.chapterFrom.resetValidation()
          this.getChapterNameListBySubjectId(obj);
          this.color = "success";
          this.subject_id = null;
          this.noticeMessage = "Success! " + response.messages;
          this.snack("top");
        } else {
          this.color = "warning";
          this.noticeMessage = "Warning! " + response.messages;
          this.snack("top");
        }
      });
      } else {
        console.log('failed')
      }
    },
    editChapter (item) {
      this.chapterObj = item
      console.log(item)
      this.dialogChapter = true
    },
    updateChapterForm (obj) {
      // console.log(obj)
      let loader = this.$loading.show({
              color: "green",
              canCancel: true,
              onCancel: this.onCancel,
              loader: 'dots',
              isFullPage: true
            });
      this.updateChapter(obj).then(response => {
        if (response.status == "OK") {
      // this.onSelectSubject(this.chapter.course_id, this.chapter.subject_id)
          this.dialogChapter = false
          this.color = "success";
          this.noticeMessage = "Success! " + response.messages;
          this.snack("top");
          loader.hide()
        } else {
          this.color = "warning";
          this.noticeMessage = "Warning! " + response.messages;
          this.snack("top");
          loader.hide()
        }
      });
    },
    closeModal () {
      this.dialogChapter = false
      this.onSelectSubject(this.chapter.course_id, this.chapter.subject_id)
    },
    snack(...args) {
      this.top = false;
      this.bottom = false;
      this.left = false;
      this.right = false;

      for (const loc of args) {
        this[loc] = true;
      }

      //   this.color = this.colors[Math.floor(Math.random() * this.colors.length)]

      this.snackbar = true;
    }
  }
};
</script>
<style scoped>
.v-btn--floating.v-btn--small {
    width: 40px;
}
</style>